import * as React from 'react';
import { compose } from 'redux';
import { withTranslator } from '@gandi/translate';
import { withAssetPath } from 'gandi.react-asset-path';
import { jsx as _jsx } from "react/jsx-runtime";
const staticComponent = WrappedComponent => {
  function Static({
    locale = 'en',
    ...extraProps
  }) {
    return /*#__PURE__*/_jsx(WrappedComponent, {
      locale: locale,
      ...extraProps
    });
  }
  return compose(withAssetPath, withTranslator({
    propsNamespace: 'translator'
  }))(Static);
};
export { staticComponent };